import { APIModel } from './api-model.model'

export class APIMessage extends APIModel {
    messageId: number;
    message: string;
    messageType: string;
    productId: number;
    messageEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        messageId: number;
        message: string;
        messageType: string;
        productId: number;
        messageEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.messageId = params.messageId
        this.message = params.message
        this.messageType = params.messageType
        this.productId = params.productId
        this.messageEnabled = params.messageEnabled ? 1 : 0
    }
}
